import { Component, OnInit,ChangeDetectorRef, NgZone, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentRestrictions } from 'ngx-google-places-autocomplete/objects/options/componentRestrictions';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { CustomerAddress } from 'src/app/models/customer-address';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { GooglePlace } from 'src/app/models/google-place';
import { CustomerAddressService } from 'src/app/services/customer-address.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { InputDialogComponent } from '../dialogs/input-dialog/input-dialog.component';
import { AddressNumberErrorDialogComponent } from '../dialogs/address-number-error-dialog/address-number-error-dialog.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss']
})
export class AddressSearchComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  adressList = Array<any>();
  searchtext = '';
  searchtextupdate = new Subject<string>();

  sessionToken = new google.maps.places.AutocompleteSessionToken();
  placesservice?: google.maps.places.PlacesService;
  autocompleteservice = new google.maps.places.AutocompleteService();
  directionsservice = new google.maps.DirectionsService();

  afterto="";

  constructor(
    private cd:ChangeDetectorRef,
    private ngzone: NgZone,
    private customeraddressservice:CustomerAddressService,
    private initializationservice:InitializationService,
    private currentinfoservice:CurrentInfoService, 
    private navigationservice:NavigationService,
    private localeservice:LocaleService,
    private route: ActivatedRoute,
    private router: Router,
    public alertDialog: MatDialog
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

    return;
    }

    this.afterto = String(this.route.snapshot.queryParamMap.get('afterto'));

    this.searchtextupdate.pipe(debounceTime(600), distinctUntilChanged()).subscribe(value => 
    {
      this.getAdressPredictions(value);
    });
  }

  ngAfterViewInit()
  {
    var placesDiv = document.getElementById('placesDiv');

    if(placesDiv instanceof(HTMLDivElement))
      this.placesservice = new google.maps.places.PlacesService(placesDiv);
  }

  chooseLocation()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/picklocation?afterto=' + this.afterto, { replaceUrl:true });
  }

  getAdressPredictions(input:string)
  {
    if(!input)
      return;
    
    var latlng = new google.maps.LatLng(this.currentinfoservice._currentInfo.PlaceLatitude, this.currentinfoservice._currentInfo.PlaceLongitude );

    this.autocompleteservice.getPlacePredictions({input:input, componentRestrictions:new ComponentRestrictions({country: this.localeservice.getCountry()}), sessionToken: this.sessionToken, location: latlng, radius: this.currentinfoservice._currentInfo.MaximumDistance * 1000, types: ["address"] }, (r, s) =>
    {
      if(s === 'OK')
      {
        this.adressList = r;

        this.cd.detectChanges();
      }
    });
  }

  addressTap(prediction: google.maps.places.AutocompletePrediction)
  {
    if(this.placesservice)
    {
      this.placesservice.getDetails({ placeId: prediction.place_id, sessionToken: this.sessionToken, fields: ["name", "url", "place_id","formatted_address", "geometry.location", 'address_components'] }, (r,s) =>
      {
        if(s === 'OK')
        {
          var place = r;

          var storePlaceID = this.currentinfoservice._currentInfo.PlaceID;

          var customerAddress = new CustomerAddress();

          customerAddress.SetDataFromAutoComplete(place, this.currentinfoservice._currentInfo.PlaceID);

          if(this.localeservice.getCountry() === 'br')
          {
            if(customerAddress.Number.length === 0)
            {
              this.sessionToken = new google.maps.places.AutocompleteSessionToken();

              this.searchtext = customerAddress.Street + " ";

              this.cd.detectChanges();

              this.ngzone.run(() =>
              {
                  var dialRef = this.alertDialog.open(AddressNumberErrorDialogComponent, 
                  {
                    height: 'fit-content',
                    width: 'fit-content',
                    data: { showpicklocation : true}
                  });

                  dialRef.afterClosed().subscribe((r) =>
                  {
                    this.ngzone.run(() =>
                    {
                      if(r)
                        this.chooseLocation();
                    });
                  });
              });

              return;
            }

            if(customerAddress.Neighborhood.length === 0)
            {
              this.ngzone.run(() =>
              {
              var dialogRef = this.alertDialog.open(InputDialogComponent, 
              {
                  height: 'fit-content',
                  width: 'fit-content',
                  data: 
                  { 
                    title: this.localeservice.instantTranslation("Dialogs.Form.Neighbourhood.Title"),
                    detail:this.localeservice.instantTranslation("Dialogs.Form.Neighbourhood.Detail"), 
                    accept:this.localeservice.instantTranslation("Dialogs.Form.Neighbourhood.Accept"), 
                    cancel:this.localeservice.instantTranslation("Dialogs.Form.Neighbourhood.Cancel"),
                    type:"text"
                  }
                });

                dialogRef.afterClosed().subscribe((r) =>
                {
                  if(typeof r === 'string' && r.length > 0)
                  {
                    customerAddress.setNeighobourhood(r);

                    if(storePlaceID && storePlaceID.length > 0 && place.place_id)
                      this.checkDistance(storePlaceID, place, customerAddress);
                  }
                });
              });

              return;
            }
          }          

          if(storePlaceID && storePlaceID.length > 0 && place.place_id)
            this.checkDistance(storePlaceID, place, customerAddress);
        }
      });
    }
  }

  checkDistance(storePlaceID:string, place: google.maps.places.PlaceResult, customerAddress: CustomerAddress)
  {
    if(storePlaceID && storePlaceID.length > 0 && place.place_id)
    {
      var request = 
      { 
        origin: new GooglePlace(storePlaceID), 
        destination:new GooglePlace(place.place_id), 
        travelMode: google.maps.TravelMode.DRIVING 
      };

      this.directionsservice.route(request, (r,s) =>
      {
        if(s === 'OK')
        {
          var distance = r.routes[0].legs[0].distance.value / 1000;

          var isWithinRange = this.currentinfoservice.isWithinOperationArea(distance)

          if(isWithinRange)
          {
            customerAddress.setDistance(distance);

            this.customeraddressservice.setCustomerAddress(customerAddress);
              
            this.ngzone.run(() =>
            {
              var appname = String(this.route.snapshot.paramMap.get('appname'));

              this.router.navigateByUrl('/' + appname + '/confirmaddress?afterto=' + this.afterto, { replaceUrl:true });
            });
          }
          else
          {
            this.sessionToken = new google.maps.places.AutocompleteSessionToken();

            this.adressList = new Array<any>();

            this.searchtext = '';

            this.ngzone.run(() =>
            {
              this.alertDialog.open(AlertDialogComponent, 
                {
                  height: 'fit-content',
                  width: 'fit-content',
                  data: 
                  { 
                    title: this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Title"),
                    detail:this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Detail"), 
                    accept:this.localeservice.instantTranslation("Dialogs.Alert.OutOfReachWarning.Accept") 
                  }
                });
            });
          }
        }
      });
    }
  }

  back()
  {
    this.navigationservice.back();
  }
}
